export const SIDEBARSHOW = 'SIDEBARSHOW';
export const ADDUSERTOKEN = 'ADDUSERTOKEN';
export const DELUSERTOKEN = 'DELUSERTOKEN';
export const ADDUSERROLE = 'ADDUSERROLE';
export const REPORTNUMBER = 'REPORTNUMBER';
export const ACTIVETAB = 'ACTIVETAB';
export const ADDHSEUSER = 'ADDHSEUSER';
export const TENANTID = 'TENANTID';
